// frontend/src/components/layout/Navbar.tsx

import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { TOP_NAV } from '../../config/navigation';
import { useAuthStore } from '../../store/authStore';
import { authService } from '../../services/auth.service';

function initials(fullName: string): string {
  return fullName
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join('');
}

// Official MinikCoder Akademi Logo SVG Component
const LogoSVG = () => (
  <svg width="36" height="36" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ filter: 'drop-shadow(0 2px 8px rgba(23, 199, 154, 0.35))' }}>
    <defs>
      <linearGradient id="dashNavBlue" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#38BDF8" />
        <stop offset="50%" stopColor="#0284C7" />
        <stop offset="100%" stopColor="#0369A1" />
      </linearGradient>
      <linearGradient id="dashNavTeal" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#17C79A" />
        <stop offset="100%" stopColor="#0B8F70" />
      </linearGradient>
    </defs>
    <path d="M 35 150 L 35 60 L 80 110 L 110 80 L 145 120 L 145 150" stroke="url(#dashNavBlue)" strokeWidth="18" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M 110 60 L 155 60 C 170 60 170 85 150 100 L 115 125 L 155 170" stroke="url(#dashNavTeal)" strokeWidth="18" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="95" cy="95" r="14" fill="#17C79A" />
    <path d="M 68 128 Q 95 102 122 128" stroke="#38BDF8" strokeWidth="12" strokeLinecap="round" />
    <rect x="150" y="25" width="12" height="12" rx="2" fill="#17C79A" />
    <rect x="168" y="10" width="8" height="8" rx="1.5" fill="#38BDF8" />
    <rect x="170" y="32" width="6" height="6" rx="1" fill="#0B8F70" />
  </svg>
);

export function Navbar() {
  const profile = useAuthStore((s) => s.profile);
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);

  async function handleSignOut() {
    await authService.signOut();
    navigate('/auth');
  }

  return (
    <nav className="app-navbar">
      <Link to="/dashboard" className="app-navbar-brand">
        <LogoSVG />
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1.1 }}>
          <span style={{ fontSize: '18px', fontWeight: 800, color: 'var(--paper)', letterSpacing: '-0.02em', fontFamily: "var(--f-body)" }}>Minik<span style={{ color: 'var(--teal)', display: 'inline' }}>Coder</span></span>
          <span style={{ fontSize: '8px', fontWeight: 700, letterSpacing: '0.16em', color: 'var(--gold-soft)', marginTop: '1px', textTransform: 'uppercase', fontFamily: "var(--f-mono)" }}>AKADEMİ</span>
        </div>
      </Link>

      {profile?.role === 'student' && (
        <div className="app-navbar-links">
          {TOP_NAV.map((item) => (
            <Link key={item.path} to={item.path}>
              {item.label}
            </Link>
          ))}
        </div>
      )}

      <div className="app-navbar-user">
        {profile?.role === 'student' && (
          <>
            <div className="app-navbar-streak">
              <span>🔥</span>
              <span>{profile.current_streak_days} Gün</span>
            </div>
            <div className="app-navbar-xp">
              <span>⭐</span>
              <span>🪙 {(profile as any)?.coins ?? 0} · ⭐ {profile.xp.toLocaleString('tr-TR')} XP</span>
            </div>
          </>
        )}

        <div className="app-navbar-avatar-wrap">
          <button
            className="app-navbar-avatar"
            onClick={() => setShowUserMenu((v) => !v)}
            aria-label="Kullanıcı menüsü"
          >
            {profile ? initials(profile.full_name) : '?'}
          </button>
          {showUserMenu && (
            <div className="app-navbar-dropdown" onMouseLeave={() => setShowUserMenu(false)}>
              <Link to="/profile" onClick={() => setShowUserMenu(false)}>
                👤 Profilim
              </Link>
              <Link to="/settings" onClick={() => setShowUserMenu(false)}>
                ⚙️ Ayarlar
              </Link>
              <button onClick={handleSignOut}>🚪 Çıkış Yap</button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
